import { Icon } from "semantic-ui-react";

const filePreview = (file, icon) => {
  const fileType = file.type;
  const isImage = fileType.includes("image");

  if (isImage) {
    return (
      <img
        src={URL.createObjectURL(file)}
        alt="preview"
        style={{ maxWidth: "20px", maxHeight: "20px" }}
      />
    );
  }

  return <Icon name={icon} size="large" />;
};

const FileCellRenderer = ({ file, icon, isRowLoading, fileLoadError }) => {
  if (isRowLoading) {
    return <span>Loading file...</span>;
  }

  if (fileLoadError) {
    return <span style={{ color: "red" }}>Failed to load</span>;
  }

  if (!file) {
    return <span>No file</span>;
  }

  const fileName = file.name;
  let formattedFileName = "";
  if (fileName && fileName.length > 10) {
    formattedFileName = `${fileName.substring(0, 8)}..`;
  } else {
    formattedFileName = fileName;
  }
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        padding: "5px 10px",
      }}
    >
      {filePreview(file, icon)}
      <span style={{ marginLeft: "10px" }}>{formattedFileName}</span>
    </div>
  );
};

export default FileCellRenderer;
